const styles = (theme) => ({
  app: {
    height: "100%",
    width: "100%",
  },
})

export default styles
